/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { kakaoTalkBizMessageControllerText } from '../fn/kakao-talk-biz-message/kakao-talk-biz-message-controller-text';
import { KakaoTalkBizMessageControllerText$Params } from '../fn/kakao-talk-biz-message/kakao-talk-biz-message-controller-text';

@Injectable({ providedIn: 'root' })
export class KakaoTalkBizMessageService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `kakaoTalkBizMessageControllerText()` */
  static readonly KakaoTalkBizMessageControllerTextPath = '/api/kakao-talk-biz-message';

  /**
   * 테스트용
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `kakaoTalkBizMessageControllerText()` instead.
   *
   * This method doesn't expect any request body.
   */
  kakaoTalkBizMessageControllerText$Response(params?: KakaoTalkBizMessageControllerText$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return kakaoTalkBizMessageControllerText(this.http, this.rootUrl, params, context);
  }

  /**
   * 테스트용
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `kakaoTalkBizMessageControllerText$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  kakaoTalkBizMessageControllerText(params?: KakaoTalkBizMessageControllerText$Params, context?: HttpContext): Observable<void> {
    return this.kakaoTalkBizMessageControllerText$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
